# require('./style.scss')
class ManagerDirective
  # @$inject: ["$rootScope", "$scope", "$state", "toasty", "editor", "warning", "Company"]
  # constructor: ($rootScope, $scope, $state, toasty, editor, warning, Company)->
  @inject: ["toasty", "warning", "editor", "Company"]
  constructor: (toasty, warning, editor, Company)->
    class Manager
      restrict: "A"
      require: ["restfulResources"]
      bindToController: true
      controllerAs: 'manager'
      controller: ($scope)->
        # $scope.logout = ()->
          # init()->
          #   $scope.
        @create = ()=>
          # console.log 'fjifoj'
          # console.log $scope.$resource
          company = new Company()
          company.company = $scope.company._id
          key = "Create"
          @edit(company, key)

        @edit = (company, key = "Edit")->
          options =
            title: key + " Company"
            source: company
            schema:
              name:
                type: "String"
                display: "Name"
                required: true
              active:
                type: "Boolean"
                display: "Active"
          editor.edit(options).then (result)->
            result.$save()
          .then (result)->
            $scope.$resource.refresh()
            toasty.success
              title: key + " Company Success"
              msg:  key + " company #{result.name} success"

        @remove = (company, $resource)->
          options =
            title: "Remove company"
            msg: "Confirm to remove #{company.name}?"
          warning.warn(options).then ()->
            company.$remove()
          .then ()=>
            $resource.refresh()
            toasty.success
              title: 'Remove Company Success'
              msg: "Remove #{company.name} success"

        edit =
          html: "<a><i class='fa fa-pencil-square-o'></i>Edit Company</a>"
          enabled: -> true
          click: (scope) =>
            {company} = scope
            @edit company

        remove =
          html: "<a><i class='fa fa-trash'></i>Remove Company</a>"
          enabled: -> true
          click: (scope) =>
            {company, $resource} = scope
            @remove(company, $resource)

        @menu = [edit, remove]

        return @

      link: ($scope, $element, $attrs, $controller) ->
        $scope.$resource = $controller[0]


    return new Manager()


module.exports = ManagerDirective



// WEBPACK FOOTER //
// ./src/component/company/manager.coffee